<script setup lang="ts">
import Modal from "@/ui/components/modal.vue";
import { useLocalStorage } from "@vueuse/core";
import ExportFileType = App.Enums.ExportFileType;

const isDialogVisible = defineModel<boolean>();

const props = defineProps<{
	dataType: string;
}>();

const emit = defineEmits<{
	(e: "download", type: ExportFileType);
}>();

const exportType = useLocalStorage<ExportFileType>(
	"exportTypePreference",
	"xlsx"
);

const exportTypes: { title: string; value: ExportFileType }[] = [
	{ title: "XLSX", value: "xlsx" },
	{ title: "CSV", value: "csv" },
];

const generateExport = () => {
	emit("download", exportType.value);
	isDialogVisible.value = false;
};
</script>

<template>
	<Modal
		:title="`Export ${props.dataType}`"
		icon="fa: fa-solid fa-download"
		v-model:visible="isDialogVisible"
		width="400px"
	>
		<v-select
			v-model="exportType"
			label="Export Type"
			:items="exportTypes"
			variant="filled"
			density="comfortable"
			hide-details="auto"
		/>

		<slot />

		<template #actions>
			<v-btn color="red" @click="isDialogVisible = false"> Cancel </v-btn>

			<v-btn
				@click="generateExport"
				color="primary"
				height="40"
				variant="flat"
				prepend-icon="mdi-download"
			>
				Generate Export
			</v-btn>
		</template>
	</Modal>
</template>

<style scoped lang="scss"></style>
